// extracted by mini-css-extract-plugin
export default {"container":"MobileMessage_container--I0t","message":"MobileMessage_message--a22","tailMessage":"MobileMessage_tailMessage--VdL"};